<nav class="navbar navbar-light">
  <a class="navbar-brand  " href="/">
    <img src="/assets/logos/movline logo black.png" height="50px" class="d-inline-block align-top ms-3 me-3" alt="">
  </a>
</nav>
